var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { class: _vm.slideInClass }, [
        _c("header", { staticClass: "titled" }, [
          _c("div", [
            _c("h1", [_vm._v(_vm._s(_vm.title || "Jetzt antworten"))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "close-container" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.closeFan.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "main",
          { ref: "main", staticClass: "scrollbar-check" },
          [
            _vm.loadingMessage
              ? _c("Loading", { attrs: { text: "Lade Nachricht..." } })
              : [
                  _vm.loadingMessageUnsuccessful
                    ? _c(
                        "div",
                        [
                          _c("JonInfo", {
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "message",
                                  fn: function() {
                                    return [
                                      _c(
                                        "p",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\tDiese Nachricht ist nicht (mehr) verfügbar. Möglicherweise ist sie bereits nicht mehr\n\t\t\t\t\t\t\taktuell.\n\t\t\t\t\t\t"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Nach Schließen der Maske aktualisiert sich die Nachrichtenliste automatisch."
                                        )
                                      ])
                                    ]
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              1165179424
                            )
                          })
                        ],
                        1
                      )
                    : [
                        _vm.isApplicantIsInterestedToo
                          ? _c("ApplicantIsInterestedToo", {
                              staticClass: "mt-4",
                              attrs: {
                                message: _vm.localMessage,
                                "declined-vita": _vm.isApplicantDeclinedVita,
                                "sent-vita": _vm.isApplicantSentVita
                              },
                              on: {
                                processed: _vm.onProcessed,
                                cancel: _vm.closeFan
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.matchingEligible
                          ? _c(
                              "div",
                              { staticClass: "mt-5" },
                              [
                                _c("Matching", {
                                  attrs: {
                                    "job-profile-id":
                                      _vm.localMessage.jobProfile.id,
                                    "job-id": _vm.localMessage.job.id
                                  },
                                  on: {
                                    loaded: function($event) {
                                      _vm.loadedMatching = true
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loadedMatching || _vm.loadedVita
                          ? _c(
                              "div",
                              { staticClass: "mt-5" },
                              [
                                _vm.showCustomerIsInterested
                                  ? _c("CustomerIsInterested", {
                                      ref: "customerIsInterested",
                                      attrs: { message: _vm.localMessage },
                                      on: {
                                        contentGrow: _vm.onContentGrow,
                                        processed: _vm.onProcessed,
                                        loading: function($event) {
                                          _vm.customerIsInterestedLoading = $event
                                        },
                                        sendoffDataChanged: function($event) {
                                          _vm.customerIsInterestedSendoffData = $event
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.localMessage.conversationStatus.id ===
                        _vm.conversationStatusList.applicantIsInterested
                          ? _c("ApplicantIsInterested", {
                              staticClass: "mt-5",
                              attrs: { message: _vm.localMessage },
                              on: { processed: _vm.onProcessed }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldShowCustomerSendAppointmentToApplicant
                          ? _c("CustomerSentAppointmentToApplicant", {
                              attrs: { message: _vm.localMessage },
                              on: { processed: _vm.onProcessed }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldShowCustomerNewAppointmentDates
                          ? _c("CustomerNewAppointmentDates", {
                              attrs: { message: _vm.localMessage },
                              on: { processed: _vm.onProcessed }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldShowCustomerPostAppointment
                          ? _c("CustomerPostAppointment", {
                              staticClass: "mt-5",
                              attrs: {
                                message: _vm.localMessage,
                                "force-took-place":
                                  _vm.customerPostAppointmentForceTookPlace
                              },
                              on: { processed: _vm.onProcessed }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldShowApplicantPostAppointment
                          ? _c("ApplicantPostAppointment", {
                              staticClass: "mt-5",
                              attrs: { message: _vm.localMessage },
                              on: { processed: _vm.onProcessed }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldShowApplicantAlternativeAppointmentPossibleForCustomer
                          ? _c(
                              "ApplicantAlternativeAppointmentPossibleForCustomer",
                              {
                                staticClass: "mt-5",
                                attrs: { message: _vm.localMessage },
                                on: { processed: _vm.onProcessed }
                              }
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldShowCollaboration
                          ? _c("Collaboration", {
                              staticClass: "mt-5",
                              attrs: { message: _vm.localMessage },
                              on: { processed: _vm.onProcessed }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.shouldShowCollaborationAccept
                          ? _c("CollaborationAccept", {
                              staticClass: "mt-5",
                              attrs: { message: _vm.localMessage },
                              on: { processed: _vm.onProcessed }
                            })
                          : _vm._e()
                      ]
                ]
          ],
          2
        ),
        _vm._v(" "),
        _vm.showCustomerIsInterested
          ? _c(
              "footer",
              [
                _vm.footerLayout ===
                _vm.footerLayouts.customerIsInterestedInterested
                  ? [
                      _c(
                        "div",
                        { staticClass: "flex-grow-1 mr-2" },
                        [
                          _c("Button", {
                            staticClass: "mr-md-4",
                            attrs: {
                              text: "Kontaktanfrage bestätigen",
                              icon: "checkmark",
                              disabled: _vm.customerIsInterestedLoading,
                              loading: _vm.customerIsInterestedLoading
                            },
                            on: {
                              click: _vm.customerIsInterestedClickedConfirm
                            }
                          }),
                          _vm._v(" "),
                          !_vm.customerIsInterestedLoading
                            ? _c(
                                "a",
                                {
                                  staticClass: "d-inline-block mt-2 mt-md-0",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.customerIsInterestedClickedInterestedCustomerUninteresting.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\tArbeitgeber nicht interessant\n\t\t\t\t"
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.customerIsInterestedLoading
                        ? _c("div", { staticClass: "mt-2 mt-md-0" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.customerIsInterestedInterestedRevert.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [_vm._v("Zurück")]
                            )
                          ])
                        : _vm._e()
                    ]
                  : _vm.footerLayout ===
                    _vm.footerLayouts.customerIsInterestedCustomerUninteresting
                  ? [
                      _c(
                        "div",
                        { staticClass: "flex-grow-1 mr-2" },
                        [
                          _c("Button", {
                            attrs: {
                              text: "Verabschiedung senden",
                              icon: "close",
                              loading: _vm.customerIsInterestedLoading,
                              disabled:
                                !_vm.customerIsInterestedCustomerUninterestingValid ||
                                _vm.customerIsInterestedLoading
                            },
                            on: {
                              click: _vm.customerIsInterestedClickedConfirm
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.customerIsInterestedLoading
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.customerIsInterestedClickedInterestedCustomerUninterestingRevert.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [_vm._v("Zurück")]
                            )
                          ])
                        : _vm._e()
                    ]
                  : _vm.footerLayout ===
                    _vm.footerLayouts.customerIsInterestedNotInterested
                  ? [
                      _c(
                        "div",
                        { staticClass: "flex-grow-1 mr-2" },
                        [
                          _c("Button", {
                            staticClass: "mt-3",
                            attrs: {
                              text: "Verabschiedung senden",
                              icon: "close",
                              disabled: _vm.customerIsInterestedLoading,
                              loading: _vm.customerIsInterestedLoading
                            },
                            on: {
                              click: _vm.customerIsInterestedClickedConfirm
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.customerIsInterestedLoading
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.customerIsInterestedClickedNotInterestedRevert.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                }
                              },
                              [_vm._v("Zurück")]
                            )
                          ])
                        : _vm._e()
                    ]
                  : [
                      _c(
                        "div",
                        { staticClass: "flex-grow-1 mr-2" },
                        [
                          _c("Button", {
                            attrs: {
                              text: "Job interessant",
                              success: "",
                              icon: "checkmark"
                            },
                            on: {
                              click: _vm.customerIsInterestedClickedInterested
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("Button", {
                            staticClass: "ml-md-5 mt-2 mt-md-0",
                            attrs: {
                              text: "Job nicht interessant",
                              secondary: "",
                              icon: "close"
                            },
                            on: {
                              click:
                                _vm.customerIsInterestedClickedNotInterested
                            }
                          })
                        ],
                        1
                      )
                    ]
              ],
              2
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }